import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15 } from "styled-components";
import React from "react";
import { translations } from "~/features/blocks/inventory/hardware-comparison-table/utils";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { useLocale } from "~/features/i18n/use-locale";
import { Button } from "~/features/ui/button";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Icon } from "~/features/ui/icon";
import { Link } from "~/features/ui/link";
import { Tag } from "~/features/ui/tag";
import { getSpecValue, type HardwareComparisonProduct, type HardwareComparisonRow } from "~/features/blocks/inventory/hardware-comparison-table";
import { useHardwareComparison } from "~/features/blocks/inventory/hardware-comparison-table/context";
import { CompressedProduct } from "~/features/blocks/inventory/hardware-comparison-table/desktop/compressed-product";
import EyeOff from "~/public/icons/eye-off.svg";
import Download from "~/public/icons/download.svg";
export function ProductColumn(props: {
  product: HardwareComparisonProduct;
  rows: HardwareComparisonRow[];
  canHide?: boolean;
  isHidden: boolean;
}) {
  const {
    theme,
    mode,
    diff,
    toggleProductColumn,
    onHoveredRow,
    hoveredRow
  } = useHardwareComparison();
  const themeStyle = getThemeStyle({
    mode: mode,
    theme: theme
  });
  const locale = useLocale();
  return <_StyledDiv>
      {props.isHidden ? <CompressedProduct product={props.product} /> : <>
          <_StyledDiv2>
            {props.canHide && <Tag variant="blur" as="button" onClick={() => {
          if (props.product.id) {
            toggleProductColumn(props.product.id);
          }
        }}>
                <_StyledSpan>
                  {translations["hide"][locale]} <Icon icon={EyeOff} size="16" />
                </_StyledSpan>
              </Tag>}
          </_StyledDiv2>
          <_StyledDiv3>
            <_StyledDiv4>
              {props.product.productImage && <Link href={props.product.url}>
                  <Asset asset={props.product.productImage as AssetProps["asset"]} imageProps={{
              fit: "cover"
            }} />
                </Link>}
            </_StyledDiv4>
            <_StyledDiv5>
              <_StyledDiv6>
                <_StyledH>{props.product?.title}</_StyledH>
                <_StyledSpan2 />
              </_StyledDiv6>
              {(props.product.productHighlights ?? []).length > 0 && <_StyledDiv7>
                  {props.product.productHighlights?.map((highlight, i) => <Tag key={i} variant="solid-light-grey">
                      {highlight}
                    </Tag>)}
                </_StyledDiv7>}
              <_StyledP>{props.product?.productCaption}</_StyledP>
            </_StyledDiv5>
            {props.product.downloadSpecsLink && <_StyledDiv8>
                <Button as={Link} href={props.product.downloadSpecsLink} newWindow variant="underline" icon={Download}>
                  {translations["downloadSpecs"][locale]}
                </Button>
              </_StyledDiv8>}
          </_StyledDiv3>

          <_StyledDiv9 $_css={[{
        "> :not([hidden]) ~ :not([hidden])": {
          "--tw-divide-y-reverse": "0",
          "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
          "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
        },
        "fontSize": "1.4rem",
        "lineHeight": "1.1",
        "letterSpacing": "0.028000000000000004rem",
        "fontWeight": "400"
      }, themeStyle.border]}>
            {props.rows.map((row, i) => <React.Fragment key={row.key ?? i}>
                <_StyledDiv10 role="presentation" onMouseOver={() => {
            onHoveredRow(i);
          }} $_css2={[{
            "display": "flex",
            "height": "5.4rem",
            "alignItems": "center",
            "paddingLeft": "2.4rem",
            "paddingRight": "2.4rem",
            "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif"
          }, themeStyle.text, i === 0 && {
            "borderTopWidth": "1px"
          }, themeStyle.border, hoveredRow === i && (mode === "dark" ? {
            "--tw-bg-opacity": "1",
            "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))"
          } : {
            "--tw-bg-opacity": "1",
            "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
          })]}>
                  <_StyledSpan3 $_css3={[diff.includes(i) && [{
              "borderRadius": "2px",
              "paddingLeft": "0.8rem",
              "paddingRight": "0.8rem",
              "lineHeight": "1.375"
            }, mode === "dark" ? {
              "--tw-bg-opacity": "1",
              "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))"
            } : {
              "--tw-bg-opacity": "1",
              "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))"
            }]]}>
                    {getSpecValue(props.product, row.key)}
                  </_StyledSpan3>
                </_StyledDiv10>
              </React.Fragment>)}
          </_StyledDiv9>
        </>}
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-1kgcpx5-0"
})({
  "position": "relative",
  "minWidth": "30.6rem"
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-1kgcpx5-1"
})({
  "position": "absolute",
  "right": "2.4rem",
  "top": "0",
  "zIndex": "10",
  "display": "flex",
  "flexWrap": "wrap",
  "justifyContent": "flex-end",
  "gap": "0.4rem",
  "padding": "0.4rem"
});
var _StyledSpan = _styled3("span").withConfig({
  componentId: "sc-sf-1kgcpx5-2"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.8rem"
});
var _StyledDiv3 = _styled4("div").withConfig({
  componentId: "sc-sf-1kgcpx5-3"
})({
  "display": "flex",
  "height": "56rem",
  "flexDirection": "column",
  "justifyContent": "flex-start",
  "paddingLeft": "2.4rem",
  "paddingRight": "2.4rem",
  "paddingBottom": "2.4rem"
});
var _StyledDiv4 = _styled5("div").withConfig({
  componentId: "sc-sf-1kgcpx5-4"
})({
  "position": "relative",
  "height": "32rem",
  "width": "100%",
  "minWidth": "25.6rem"
});
var _StyledDiv5 = _styled6("div").withConfig({
  componentId: "sc-sf-1kgcpx5-5"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.8rem"
});
var _StyledDiv6 = _styled7("div").withConfig({
  componentId: "sc-sf-1kgcpx5-6"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1.6rem",
  "paddingTop": "1.6rem"
});
var _StyledH = _styled8("h2").withConfig({
  componentId: "sc-sf-1kgcpx5-7"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledSpan2 = _styled9("span").withConfig({
  componentId: "sc-sf-1kgcpx5-8"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledDiv7 = _styled10("div").withConfig({
  componentId: "sc-sf-1kgcpx5-9"
})({
  "display": "flex",
  "flexWrap": "wrap",
  "gap": "0.4rem"
});
var _StyledP = _styled11("p").withConfig({
  componentId: "sc-sf-1kgcpx5-10"
})({
  "marginTop": "0.8rem",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400"
});
var _StyledDiv8 = _styled12("div").withConfig({
  componentId: "sc-sf-1kgcpx5-11"
})({
  "marginRight": "auto",
  "marginTop": "auto"
});
var _StyledDiv9 = _styled13("div").withConfig({
  componentId: "sc-sf-1kgcpx5-12"
})`${p => p.$_css}`;
var _StyledDiv10 = _styled14("div").withConfig({
  componentId: "sc-sf-1kgcpx5-13"
})`${p => p.$_css2}`;
var _StyledSpan3 = /*#__PURE__*/_styled15("span").withConfig({
  displayName: "product-column___StyledSpan3",
  componentId: "sc-13n1fnv-0"
})(["", ""], p => p.$_css3);